module.exports = __webpack_public_path__ + "static/img/OnBoardingQRCode.c14d807.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/OnBoardingQRCode.png
// module id = Fp8U
// module chunks = 3